export const articles = [
  {
    slug: "cheng-yiye-su-nian-santong-kuang",
    title: "程亦野苏念三度同框被拍，双方工作室先后发文回应",
    excerpt:
      "两人合作的新剧杀青后接连被拍到同行画面，从剧组探班到深夜聚餐，话题一路冲上热搜前排，双方工作室也在同一天内先后发文。",
    category: "明星恋情",
    categorySlug: "romance",
    tags: ["程亦野", "苏念", "新剧", "同框"],
    author: "瓜田速报组",
    date: "2026-09-10",
    readTime: "5 分钟",
    heat: 98600,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20two%20overlapping%20warm%20coral%20rings%20intersecting%20over%20cream%20paper%20texture%20with%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20clean%20modern%20composition%2C%20soft%20diffused%20studio%20lighting&width=1200&height=800&seq=gw-a-romance-01&orientation=landscape",
    coverAlt: "程亦野苏念同框话题相关配图",
    featured: true,
    keyPoints: [
      "两人新剧杀青后半月内被拍到三次同行画面",
      "双方工作室同一天先后发文，措辞都强调「关注作品」",
      "话题热度在当晚达到峰值，讨论集中在剧组关系上",
    ],
    sections: [
      {
        heading: "三次同框的时间线",
        paragraphs: [
          "事情的起点要追溯到新剧杀青当天。剧组工作人员在社交平台分享了一张杀青合照，程亦野和苏念站在队伍中间位置，被眼尖的网友截出来单独讨论，第一次同框话题由此出现。",
          "第二次是同月下旬的一次聚餐。有路人拍到两人先后走进同一家餐厅，同行还有剧组的两位编剧。第三次则是上周的深夜时段，两人被拍到在停车场短暂交谈。三次画面叠加起来，话题的讨论量在短时间内集中发酵。",
        ],
      },
      {
        heading: "双方工作室的回应",
        paragraphs: [
          "程亦野工作室在当天下午率先发文，表示演员目前的工作重心是后续剧本围读，对于私人行程不便占用公共资源，并请大家继续关注作品。",
          "苏念工作室则在晚间发布类似口径的说明，提到两人因合作结缘、私下相处融洽，属于正常的同事往来。两份声明的发布时间相隔不到六小时，措辞都刻意保持了克制。",
        ],
      },
      {
        heading: "网友怎么看",
        paragraphs: [
          "话题下大致分成两派。一派认为合作期间来往密切很正常，不必过度解读；另一派则把三次画面的细节逐一拆解，试图找出更多线索。",
          "也有不少观众表示，与其纠结感情状态，不如期待两人的新剧上线。目前该剧已经进入后期制作,平台尚未公布具体排播时间。",
        ],
      },
    ],
  },
  {
    slug: "gu-yanzhi-new-film-dingdang",
    title: "顾言之新片定档国庆，首支预告放出三分钟长镜头",
    excerpt:
      "导演顾言之的新作正式宣布定档国庆档，首支预告片里那段接近三分钟不剪辑的城市长镜头，成了当天讨论度最高的话题。",
    category: "作品动态",
    categorySlug: "works",
    tags: ["顾言之", "定档", "国庆档", "预告片"],
    author: "瓜田速报组",
    date: "2026-09-10",
    readTime: "4 分钟",
    heat: 87400,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20film%20strip%20curving%20through%20geometric%20blocks%20in%20amber%20gold%20and%20deep%20teal%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-works-02&orientation=landscape",
    coverAlt: "顾言之新片定档相关配图",
    featured: true,
    keyPoints: [
      "影片正式定档国庆档首日，票价与排片信息随后公布",
      "首支预告以一段近三分钟的长镜头开场，全程没有剪辑点",
      "主创表示长镜头实拍完成，为此提前排练了整整两周",
    ],
    sections: [
      {
        heading: "为什么一个长镜头能刷屏",
        paragraphs: [
          "预告片开场，镜头从清晨的老城区出发，穿过早市、天桥、公交站，最后停在一栋居民楼的阳台上，全程没有任何剪辑点。对于习惯了快节奏剪辑的观众来说，这种处理方式本身就构成了记忆点。",
          "有影迷把这段镜头逐帧分析，试图找出隐藏的转场痕迹，结论是现场调度完成度很高，能看出剧组在走位和光线上的反复打磨。",
        ],
      },
      {
        heading: "主创的说法",
        paragraphs: [
          "顾言之在映后交流中提到，这段长镜头前后排练了两周，正式拍摄换了三天时间，天气和群众演员的状态都成了变量。他坦言这是整部影片最折磨人的一场戏。",
          "摄影指导补充说，为了配合镜头运动，团队把沿街几处光源全部重新布置，部分段落甚至拆掉了原本的路灯灯罩。",
        ],
      },
      {
        heading: "档期竞争格局",
        paragraphs: [
          "今年国庆档的排片相当密集，同档期还有两部体量相近的类型片。业内普遍认为，顾言之这次走的是口碑驱动路线，长镜头预告正是为了先立住「值得进影院」的印象。",
          "影片的正式票务信息将在下周陆续公布，目前释出的物料以氛围向内容为主。",
        ],
      },
    ],
  },
  {
    slug: "baixi-variety-save-scene",
    title: "白溪综艺临场救场名场面复盘，一句话把全场逗笑",
    excerpt:
      "节目录制到一半嘉宾突然卡壳，白溪接了一句自嘲把气氛拉了回来，这段画面播出后当晚就被剪成各种版本流传。",
    category: "综艺名场面",
    categorySlug: "variety",
    tags: ["白溪", "综艺", "救场", "名场面"],
    author: "吃瓜编辑部",
    date: "2026-09-09",
    readTime: "4 分钟",
    heat: 76200,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20with%20exploding%20concentric%20sound%20wave%20circles%20and%20spark%20shapes%20in%20warm%20coral%20amber%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-variety-03&orientation=landscape",
    coverAlt: "白溪综艺救场名场面相关配图",
    featured: false,
    keyPoints: [
      "嘉宾在互动环节突然忘词，现场安静了将近二十秒",
      "白溪用一句自嘲把节奏拉了回来，全场随即笑开",
      "该片段播出后成为当晚传播最广的综艺画面",
    ],
    sections: [
      {
        heading: "现场发生了什么",
        paragraphs: [
          "这一幕出现在节目的第二个互动环节。原本设定是嘉宾轮流接梗，但轮到某位嘉宾时，对方明显愣了一下，话筒拿在手里却始终没有开口，现场安静了将近二十秒。",
          "就在导演组准备切广告的间隙，白溪顺势把手里的题卡翻了过来，笑着调侃自己台词背得比对方还熟，一句话把注意力引回自己身上。",
        ],
      },
      {
        heading: "为什么救得漂亮",
        paragraphs: [
          "综艺救场最怕的是越救越尴尬，白溪的做法是把「卡壳」这件事本身变成笑点，让嘉宾不至于下不来台。她之后又主动把话题抛回到对方擅长的领域，让对方顺利接上了后面的流程。",
          "有做过现场导演的网友点评说，这类临场反应考验的是对嘉宾性格的熟悉程度，白溪显然提前做过功课。",
        ],
      },
      {
        heading: "后续发酵",
        paragraphs: [
          "片段播出后，相关二创在两天内出现了十几个版本，节目组也顺势放出了未播出的花絮。这期节目的完播率是本赛季目前为止最高的一期。",
        ],
      },
    ],
  },
  {
    slug: "lin-wanxing-red-carpet-look",
    title: "林晚星红毯造型换风格，复古缎面长裙成当晚讨论度最高",
    excerpt:
      "一向走清爽路线的林晚星这次选了复古缎面长裙配低盘发，造型团队的整体思路也被网友拿来逐帧点评。",
    category: "时尚造型",
    categorySlug: "fashion",
    tags: ["林晚星", "红毯", "造型", "缎面"],
    author: "瓜田速报组",
    date: "2026-09-09",
    readTime: "3 分钟",
    heat: 68400,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20satin%20fabric%20ribbons%20and%20torn%20paper%20layers%20in%20coral%20rose%20amber%20gold%20on%20cream%20background%2C%20halftone%20texture%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-fashion-04&orientation=landscape",
    coverAlt: "林晚星红毯造型相关配图",
    featured: false,
    keyPoints: [
      "造型从清爽路线切换到复古缎面，整体色调偏暖",
      "低盘发搭配耳侧留出的碎发，被认为是最加分的一处细节",
      "相关话题在造型类讨论中登上当晚第一位",
    ],
    sections: [
      {
        heading: "这次的造型思路",
        paragraphs: [
          "缎面材质在镜头下很容易显反光，造型团队的处理方式是降低整体亮度，把重点放在肩颈线条上。低盘发刻意留出的两缕碎发,中和了缎面的正式感。",
          "配饰方面只保留了耳饰，没有再叠加项链，视觉重心因此更集中。",
        ],
      },
      {
        heading: "网友的评价",
        paragraphs: [
          "评论区里出现频率最高的词是「耐看」。不少观众表示，这类造型放在红毯上第一眼不算最抢眼，但翻看返图时反而最经得起推敲。",
          "也有造型师博主指出，缎面长裙对身形比例要求很高，能穿出效果说明前期的试装投入了不少时间。",
        ],
      },
    ],
  },
  {
    slug: "lu-zhiyao-tour-finale",
    title: "陆知遥巡回演唱会收官站加唱四首，返场整整二十分钟",
    excerpt:
      "收官站的返场环节比原定流程多出四首歌，陆知遥在台上说这是送给一路跟过来的观众，散场后相关话题一直挂在高位。",
    category: "偶像舞台",
    categorySlug: "stage",
    tags: ["陆知遥", "演唱会", "收官", "返场"],
    author: "吃瓜编辑部",
    date: "2026-09-08",
    readTime: "4 分钟",
    heat: 64100,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20with%20abstract%20spotlight%20beam%20and%20starburst%20shapes%20in%20deep%20teal%20amber%20gold%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-stage-05&orientation=landscape",
    coverAlt: "陆知遥巡回演唱会收官站相关配图",
    featured: false,
    keyPoints: [
      "返场环节比原定歌单多出四首，总时长接近二十分钟",
      "现场观众全程跟唱，安可呼喊持续了将近五分钟",
      "主办方随后发布收官站限定合照，未加印周边",
    ],
    sections: [
      {
        heading: "返场多出来的四首",
        paragraphs: [
          "按照原定流程，收官站在主歌单结束后即可收灯。但安可呼喊持续了将近五分钟，陆知遥重新上台后没有按流程走，而是连着唱了四首此前巡演中没有出现过的曲目。",
          "其中有两首是早期作品，现场观众几乎全程跟唱，音浪一度盖过了伴奏。",
        ],
      },
      {
        heading: "舞台之外的花絮",
        paragraphs: [
          "演出结束后，主办方发布了收官站的限定合照，并说明这次不额外加印周边,把预算留给了下一轮制作。",
          "陆知遥在台上说，这一轮巡演走了十一个城市，最想感谢的是一路跟过来的观众。",
        ],
      },
    ],
  },
  {
    slug: "short-drama-new-players",
    title: "短剧赛道再添新玩家，一批传统影视演员转向竖屏",
    excerpt:
      "近半年里，越来越多有长剧经验的演员出现在竖屏短剧的演员表里，背后的选角逻辑和片酬结构正在发生变化。",
    category: "行业观察",
    categorySlug: "industry",
    tags: ["短剧", "行业观察", "演员", "趋势"],
    author: "瓜田观察室",
    date: "2026-09-08",
    readTime: "6 分钟",
    heat: 52300,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20bar%20chart%20blocks%20and%20grid%20lines%20in%20warm%20coral%20deep%20teal%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-industry-06&orientation=landscape",
    coverAlt: "短剧赛道行业观察相关配图",
    featured: false,
    keyPoints: [
      "竖屏短剧的选角标准正在向有长剧经验的演员倾斜",
      "拍摄周期普遍在两周以内，对演员档期要求更灵活",
      "片酬结构从「单集计价」转向「分成 + 底薪」的组合方式",
    ],
    sections: [
      {
        heading: "选角口味变了",
        paragraphs: [
          "过去提到短剧，业内第一反应往往是「快」，对表演完成度的要求并不高。但从今年上半年开始，几家头部制作方在选角时明显更看重演员的镜头经验,尤其是有过长剧文戏训练的演员。",
          "一位不愿具名的选角导演表示，观众的审美在快速变化，一些靠夸张表情撑场的表演方式已经很难带来留存。",
        ],
      },
      {
        heading: "拍摄与片酬结构",
        paragraphs: [
          "竖屏短剧的拍摄周期普遍控制在两周以内，单日拍摄强度高，但对演员档期的占用相对灵活。这也让不少在长剧空档期的演员愿意尝试。",
          "片酬方面，底薪 + 流量分成的组合方式正在变成主流。对制作方来说，这降低了前期现金压力；对演员来说，则意味着收益与作品表现直接挂钩。",
        ],
      },
      {
        heading: "冷静看待热度",
        paragraphs: [
          "需要指出的是，短剧的整体产能仍然过剩，真正能跑出来的作品比例并不高。演员转向竖屏并不意味着一定能拿到好剧本。",
          "对于观众而言，判断标准其实很简单：故事能不能在两分钟内抓住人。这一点和屏幕是横是竖没有关系。",
        ],
      },
    ],
  },
  {
    slug: "tang-zhi-rumor-denied",
    title: "唐芷与同行男子深夜同回小区？粉丝团连夜发文澄清",
    excerpt:
      "一段夜间街拍让唐芷的私人行程再次被推上讨论，粉丝团随后发布长文澄清同行人员身份，话题在凌晨逐渐降温。",
    category: "明星恋情",
    categorySlug: "romance",
    tags: ["唐芷", "澄清", "街拍", "粉丝团"],
    author: "瓜田速报组",
    date: "2026-09-07",
    readTime: "4 分钟",
    heat: 48900,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20with%20abstract%20moonlit%20warm%20coral%20and%20deep%20teal%20shapes%20and%20halftone%20dots%20on%20cream%20paper%20texture%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20clean%20modern%20composition%2C%20soft%20diffused%20studio%20lighting&width=1200&height=800&seq=gw-a-romance-07&orientation=landscape",
    coverAlt: "唐芷街拍话题相关配图",
    featured: false,
    keyPoints: [
      "街拍画面时间为深夜，同行人员只露出侧影",
      "粉丝团长文说明同行者为团队工作人员",
      "话题热度在凌晨逐步回落，未被当事人正面回应",
    ],
    sections: [
      {
        heading: "画面里有什么",
        paragraphs: [
          "流传的街拍只有短短十几秒，画面中唐芷与一名同行男子先后进入同一小区，全程没有正面镜头，同行人员的身份也难以辨认。",
          "由于拍摄时间在深夜，加上画面质量有限，这段视频本身并不足以支撑太多判断。",
        ],
      },
      {
        heading: "粉丝团的说明",
        paragraphs: [
          "当晚凌晨，唐芷粉丝团发布长文，说明同行人员为团队负责行程的工作人员，并呼吁大家不要传播未经核实的信息。",
          "长文同时提醒，艺人近期正在为舞台作品做准备，希望讨论能回到作品本身。",
        ],
      },
      {
        heading: "理性吃瓜提醒",
        paragraphs: [
          "需要说明的是，仅凭几秒钟的街拍很难得出任何结论。在没有当事人回应之前，把未核实的信息当成事实传播，对任何人都没有好处。",
        ],
      },
    ],
  },
  {
    slug: "jiang-zhao-new-drama-start",
    title: "江照新剧开机路透，为角色减重十五斤",
    excerpt:
      "新剧的开机路透里，江照比上一部作品明显清瘦，造型团队为角色调整了整套服装尺寸，剧照随后公开。",
    category: "作品动态",
    categorySlug: "works",
    tags: ["江照", "开机", "路透", "新剧"],
    author: "吃瓜编辑部",
    date: "2026-09-07",
    readTime: "3 分钟",
    heat: 45700,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20measurement%20lines%20and%20geometric%20blocks%20in%20warm%20coral%20amber%20gold%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-works-08&orientation=landscape",
    coverAlt: "江照新剧开机路透相关配图",
    featured: false,
    keyPoints: [
      "开机路透显示江照较上一部作品明显清瘦",
      "团队为其调整了整套服装尺寸，造型偏冷色调",
      "官方剧照在开机次日公开，角色设定同步释出",
    ],
    sections: [
      {
        heading: "为角色做了哪些准备",
        paragraphs: [
          "从开机路透来看，江照为这个角色减重了大约十五斤，脸部轮廓和肩线都比上一部作品更清瘦。造型团队随后把整套服装重新量体调整。",
          "据现场工作人员透露，他为角色提前一个月开始控制饮食，并跟随表演老师做了方言训练。",
        ],
      },
      {
        heading: "角色与剧集信息",
        paragraphs: [
          "官方剧照在开机次日公布，角色设定是一个在小城里寻找旧事真相的年轻人，整体色调偏冷。剧集预计拍摄三个月，具体排播时间尚未确定。",
        ],
      },
    ],
  },
  {
    slug: "ke-yu-variety-debut",
    title: "柯屿综艺首秀紧张到忘词，前辈一句话化解尴尬",
    excerpt:
      "第一次上综艺的柯屿在自我介绍环节突然忘词，前辈顺手把话题接了过去，这段画面被剪进了正片。",
    category: "综艺名场面",
    categorySlug: "variety",
    tags: ["柯屿", "综艺首秀", "忘词", "前辈"],
    author: "瓜田速报组",
    date: "2026-09-06",
    readTime: "3 分钟",
    heat: 41200,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20with%20playful%20rounded%20shapes%20and%20speech%20bubble%20forms%20in%20warm%20coral%20amber%20gold%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-variety-09&orientation=landscape",
    coverAlt: "柯屿综艺首秀相关配图",
    featured: false,
    keyPoints: [
      "柯屿在自我介绍环节忘词，停顿了约十秒",
      "同场前辈顺势接过话头，把流程带回正轨",
      "节目组把这段画面保留进了正片，反而成了亮点",
    ],
    sections: [
      {
        heading: "忘词现场",
        paragraphs: [
          "柯屿的自我介绍原本只有短短三句话，但说到第二句时他突然停住，低头看了一眼提词卡，停顿了约十秒。",
          "同场的一位前辈随即接过话头，笑着说第一次都会这样，顺势把流程带回了正轨。",
        ],
      },
      {
        heading: "为什么被保留进正片",
        paragraphs: [
          "节目组没有剪掉这段，反而把它放在了开场位置。剪辑师的思路是，真实的手足无措比完美的开场更有人情味。",
          "柯屿本人在后续采访中也自嘲了这件事，表示以后一定提前把台词背熟。",
        ],
      },
    ],
  },
  {
    slug: "ye-qinghe-airport-scarf",
    title: "叶青禾机场私服被扒同款，一条围巾三天卖断货",
    excerpt:
      "叶青禾在机场被拍到的一条针织围巾，被网友找出品牌和配色后迅速售罄，造型讨论顺带带火了一个小众品牌。",
    category: "时尚造型",
    categorySlug: "fashion",
    tags: ["叶青禾", "机场私服", "同款", "围巾"],
    author: "吃瓜编辑部",
    date: "2026-09-06",
    readTime: "3 分钟",
    heat: 38500,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20soft%20knitted%20texture%20swatches%20and%20abstract%20thread%20lines%20in%20coral%20rose%20amber%20gold%20on%20cream%20background%2C%20halftone%20texture%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-fashion-10&orientation=landscape",
    coverAlt: "叶青禾机场私服相关配图",
    featured: false,
    keyPoints: [
      "机场私服中的针织围巾被网友迅速认出品牌",
      "该配色在三天内售罄，二手平台出现溢价转卖",
      "整体穿搭走低饱和路线，配色克制",
    ],
    sections: [
      {
        heading: "一条围巾带火一个品牌",
        paragraphs: [
          "这套私服整体偏低调，深色外套配同色系长裤，唯一跳出来的是那条针织围巾。有网友顺着图找到了品牌和具体配色，链接发出后不到三天，该配色就显示售罄。",
          "二手平台上随后出现了一些溢价转卖的帖子，品牌方暂未回应是否会补货。",
        ],
      },
      {
        heading: "穿搭思路",
        paragraphs: [
          "这套搭配的可借鉴之处在于配色克制，全身只有一处亮色，其他单品都退到背景里。对于日常通勤来说，这种方式比堆叠单品更好复制。",
        ],
      },
    ],
  },
  {
    slug: "wen-ke-costume-drama-join",
    title: "温可官宣进组古装大制作，角色设定首度曝光",
    excerpt:
      "温可正式宣布加入一部古装大制作，官方同步释出角色设定，这也是她时隔两年再次挑战古装题材。",
    category: "作品动态",
    categorySlug: "works",
    tags: ["温可", "古装", "进组", "角色"],
    author: "瓜田速报组",
    date: "2026-09-05",
    readTime: "4 分钟",
    heat: 35600,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20ink%20brush%20strokes%20and%20layered%20paper%20shapes%20in%20deep%20teal%20amber%20gold%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-works-11&orientation=landscape",
    coverAlt: "温可进组古装剧相关配图",
    featured: false,
    keyPoints: [
      "温可时隔两年再次挑战古装题材，角色设定已公布",
      "剧集为群像结构，她的角色是贯穿主线的关键人物",
      "造型物料显示这次以素色戏服为主",
    ],
    sections: [
      {
        heading: "角色设定",
        paragraphs: [
          "官方释出的角色设定显示，温可饰演的角色是贯穿全剧主线的关键人物，初期以医馆学徒身份登场，随着剧情推进逐渐牵出旧案。",
          "这是她时隔两年再次挑战古装题材，造型物料里以素色戏服为主，整体风格偏写实。",
        ],
      },
      {
        heading: "剧集结构",
        paragraphs: [
          "该剧采用群像结构，主要角色有六位，各自有独立的故事线。制作方表示会尽量避免用复杂的服化道堆砌质感，把重点放在人物关系上。",
        ],
      },
    ],
  },
  {
    slug: "summer-box-office-review",
    title: "暑期档票房复盘：中小成本影片为何频频逆袭",
    excerpt:
      "今年暑期档出现了多部低成本影片跑赢大盘的情况，从题材选择到宣发节奏，这些作品的做法有一定的共性。",
    category: "行业观察",
    categorySlug: "industry",
    tags: ["暑期档", "票房", "复盘", "中小成本"],
    author: "瓜田观察室",
    date: "2026-09-05",
    readTime: "6 分钟",
    heat: 32800,
    cover:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20rising%20bar%20blocks%20and%20arrow%20grid%20in%20warm%20coral%20amber%20gold%20deep%20teal%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=1200&height=800&seq=gw-a-industry-12&orientation=landscape",
    coverAlt: "暑期档票房复盘相关配图",
    featured: false,
    keyPoints: [
      "多部中小成本影片的票房表现超过映前预期",
      "共同点是题材切口小、情绪落点明确",
      "宣发更依赖点映口碑而非前期大规模投放",
    ],
    sections: [
      {
        heading: "三个共性",
        paragraphs: [
          "复盘下来，跑赢预期的中小成本影片大多具备三个共性：题材切口足够小、主角目标足够具体、情绪落点足够明确。观众在映前就能大致判断自己会不会喜欢。",
          "与之相对，一些投入更大的影片反而因为元素过多、卖点模糊，在口碑扩散阶段掉了队。",
        ],
      },
      {
        heading: "宣发节奏的变化",
        paragraphs: [
          "今年一个明显的变化是点映被用得更克制也更精准。多部影片选择在正式上映前做小范围放映，靠真实口碑完成第一轮扩散，而不是靠铺天盖地的物料投放。",
          "这种做法的风险在于，一旦点映口碑不及预期，反而会提前消耗热度。所以片方对点映场次和城市的选择格外谨慎。",
        ],
      },
      {
        heading: "对行业的启示",
        paragraphs: [
          "预算大小并不是决定性的。真正被反复验证的一点是，把故事讲清楚、把情绪说到位，比堆砌标签更有效。",
          "对观众来说，这或许是个好消息：选择越来越多，判断成本反而在下降。",
        ],
      },
    ],
  },
];